import { localStorage } from './helpers';

// both of these should be falsy values to account for usages where the status is not specifically checked
export const localStorageItemStatus = {
  DOES_NOT_EXIST: null,
  EXPIRED: false,
};

export function setLocalStorageItemWithExpiry(key, value, ttl) {
  const now = new Date();

  // `item` is an object which contains the original value
  // as well as the time when it's supposed to expire
  const item = {
    value,
    expiry: now.getTime() + ttl,
  };
  localStorage.setItem(key, JSON.stringify(item));
}

export function getLocalStorageItemWithExpiry(key) {
  const itemStr = localStorage.getItem(key);

  // if the item doesn't exist, return null
  if (!itemStr) {
    return localStorageItemStatus.DOES_NOT_EXIST;
  }

  const item = JSON.parse(itemStr);
  const now = new Date();

  // compare the expiry time of the item with the current time
  if (now.getTime() > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return null
    localStorage.removeItem(key);
    return localStorageItemStatus.EXPIRED;
  }
  return item.value;
}
